import { Theme } from '@config/themes/ITheme';
import React from 'react';

export const createMessageStyles = (
  theme: Theme
): Record<string, React.CSSProperties> => ({
  messagesContainer: {
    position: 'absolute',
    top: '20px',
    left: '75%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    zIndex: 10000,
    pointerEvents: 'none',
    userSelect: 'none',
  },
  messageBox: {
    color: theme.colors.text,
    fontSize: '14px',
    fontWeight: '500',
    boxShadow: theme.uiElements.card.shadow,
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'auto',
    backdropFilter: 'blur(5px)',
    userSelect: 'none',
  },
  messageSuccess: {
    position: 'relative',
    justifyContent: 'space-around',
    borderRadius: '26px',
    textAlign: 'center',
    display: 'flex',
    height: '56px',
    alignItems: 'center',
    paddingTop: '5px',
    paddingBottom: '5px',
    marginBottom: '1rem',
    boxShadow: '0 0 8px #0000004d',
    background: '#123405',
    border: '1px solid #427f00',
    width: '320px',
  },
  messageError: {
    background: '#b3021b',
    borderColor: '1px solid #d8001e',
    padding: '6px 16px',
    userSelect: 'none',
    borderRadius: '10px',
    boxShadow: '0 0 8px #0000004d',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    minWidth: '317px',
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 500,
    position: 'relative',
  },

  messageSuccessLeft: {
    textAlign: 'center',
    userSelect: 'none',
    width: '100px',
    margin: '10px',
  },
  messageSuccessCenter: {
    background: '#28a909',
    borderRadius: '36px',
    textAlign: 'center',
    boxShadow: 'inset 0 -2px 4px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: 'white',
    position: 'relative',
    minWidth: '150px',
    userSelect: 'none',
  },
  messageCloseButton: {
    background: 'transparent',
    border: 'none',
    color: ' #97a4ae',
    opacity: 0.8,
    fontSize: '1.5rem',
    fontWeight: 700,
    cursor: 'pointer',
    lineHeight: 1,
    padding: '0 4px',
    margin: 0,
    marginLeft: '10px',
    textShadow: '0 1px 0 #97a4ae',
    transition: 'opacity 0.2s ease',
    userSelect: 'none',
    boxShadow: 'none',
  },
});
